<template>
  <div>
    <Toolbar />
    <PartnerPage />
    <FooterPane />
  </div>
</template>

<script>
import Toolbar from '@/nfmp_components/domain_components/Toolbar.vue'
import PartnerPage from '@/nfmp_components/Partners.vue'
import FooterPane from '@/nfmp_components/domain_components/Footer.vue'

export default {
  components: {
    Toolbar,
    PartnerPage,
    FooterPane
  }
}
</script>